interface ErrorInfo {
  type: string;
  message: string;
}

interface SiteInfoData {
  name: string;
  status: string;
  cumulativeFlow: string;
  installationDate: string;
  lastInspection: string | { date: string; title: string };
  hasError: boolean;
  errorCount: number;
  errors: ErrorInfo[];
}

interface SiteInfoSectionProps {
  data: SiteInfoData;
  expanded?: boolean;
}

const getStatusColor = (status: string) => {
  switch (status) {
    case '활성':
      return 'bg-green-100 text-green-800';
    case '점검':
      return 'bg-yellow-100 text-yellow-800';
    case '대기':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export default function SiteInfoSection({ data }: SiteInfoSectionProps) {
  const lastInspectionText =
    typeof data.lastInspection === 'object'
      ? data.lastInspection.date
      : data.lastInspection;

  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        현장 세부 정보
      </h3>

      <div className="space-y-3">
        {/* 현장명 */}
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">현장명</span>
          <span className="text-sm font-medium text-gray-900">{data.name}</span>
        </div>

        {/* 상태 */}
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">상태</span>
          <span
            className={`text-xs px-2 py-1 rounded-full ${getStatusColor(data.status)}`}
          >
            {data.status}
          </span>
        </div>

        {/* 누적 유량 */}
        {/* <div className="flex justify-between">
          <span className="text-sm text-gray-600">누적 유량</span>
          <span className="text-sm font-medium text-gray-900">
            {data.cumulativeFlow}
          </span>
        </div> */}

        {/* 설치일 */}
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">설치일</span>
          <span className="text-sm font-medium text-gray-900">
            {data.installationDate}
          </span>
        </div>

        {/* 최근 점검 */}
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">최근 점검</span>
          <span className="text-sm font-medium text-gray-900">
            {lastInspectionText}
          </span>
        </div>

        {/* 에러 상태 표시 */}
        {data.hasError && (
          <div className="mt-4 p-3 bg-red-50 rounded-lg border border-red-200">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <i className="ri-error-warning-line text-red-500"></i>
              </div>
              <div className="ml-3">
                <h4 className="text-sm font-medium text-red-800">
                  현재 {data.errorCount}개의 오류 발생
                </h4>
                {
                  <div className="mt-2 text-xs text-red-700">
                    {data.errors.map((error, index) => (
                      <div key={index} className="mb-1">
                        • {error.message}
                      </div>
                    ))}
                  </div>
                }
              </div>
            </div>
          </div>
        )}

        {/* 축소된 뷰에서는 간단한 에러 표시
        {!expanded && data.hasError && (
          <div className="mt-4 p-3 bg-red-50 rounded-lg border border-red-200">
            <div className="flex items-center">
              <i className="ri-error-warning-line text-red-500 mr-2"></i>
              <span className="text-sm font-medium text-red-800">
                {data.errorCount}개 오류 발생
              </span>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}
